export enum Weight {
  Kg = "kg",
}
